module.exports = __webpack_public_path__ + "img/flow_live.03ccf2da.png";